import Button from 'apollo-react/components/Button';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import LoginHeading from './LoginHeading';
import { checkPasskeyCredentialsIfNeeded } from '../../../actions/CredentialActions';
import { useTranslation } from '../../../custom-hooks/useTranslation';

const OfflineLogin = () => {
  const dispatch = useDispatch();
  const translateString = useTranslation();

  useEffect(() => {
    document.title = translateString('Offline Login');
  }, [translateString]);

  const handleOnClick = () => {
    dispatch(checkPasskeyCredentialsIfNeeded(false));
  };

  return (
    <div className="login-form">
      <LoginHeading text="Log in" />
      <Button
        type="submit"
        className="login-input"
        color="primary"
        id="login-btn"
        ui-ta="login-btn"
        variant="primary"
        onClick={handleOnClick}
      >
        {translateString('Log in offline')}
      </Button>
    </div>
  );
};

export default OfflineLogin;
